
import React, { useRef } from 'react';

const CondicionesServicio = () => {

    

    

    return (
        <div className="container">

          

            <h4><b>Términos y Condiciones del Servicio de APATECH TOOL</b></h4>

          <p>  Estos términos y condiciones ("Términos") regulan el uso del servicio proporcionado por APATECH DO  a través de la aplicación APATECH TOOL. Al acceder y utilizar nuestros servicios, aceptas cumplir con estos términos.
</p>
            <h5><b>Uso del Servicio</b></h5>

         1. Al utilizar nuestra aplicación, te comprometes a cumplir con todas las leyes y regulaciones aplicables.

             <p> 2. No puedes utilizar nuestros servicios para actividades ilegales, fraudulentas o no autorizadas.
</p> 
            <h5><b>Cuentas de Usuario</b></h5>

            1. Puedes necesitar crear una cuenta para acceder a ciertas funciones de la aplicación. Eres responsable de mantener la confidencialidad de tus credenciales de inicio de sesión.

       <p>     2. Nos reservamos el derecho de suspender o cancelar cuentas que violen estos términos o sean utilizadas de manera inapropiada.
</p>
           <h5><b>Propiedad Intelectual</b></h5>

          1. Todo el contenido presente en nuestra aplicación, incluyendo pero no limitado a textos, imágenes, logotipos y software, está protegido por derechos de autor y otras leyes de propiedad intelectual.

             <p> 2. No puedes copiar, modificar, distribuir o utilizar nuestro contenido sin nuestro permiso previo por escrito.
</p>
            <h5><b>Cambios en el Servicio</b></h5>

            Nos reservamos el derecho de modificar, suspender o discontinuar cualquier parte de nuestros servicios en cualquier momento y sin previo aviso.

           <h5><b>Limitación de Responsabilidad</b></h5>

            1. No garantizamos que nuestros servicios serán ininterrumpidos, seguros o libres de errores.

            <p>    2. No seremos responsables por daños directos, indirectos, incidentales, especiales o consecuentes resultantes del uso o la imposibilidad de utilizar nuestros servicios.
</p>
           <h5><b>Política de Privacidad</b></h5>

            Nuestra Política de Privacidad  <a href={"PoliticaPrivacidad"} target="_blank">Politicas de privacidad</a> describe cómo recopilamos, utilizamos y protegemos la información de los usuarios.

            <h5><b>Contacto</b></h5>

            Si tienes preguntas o inquietudes sobre estos Términos y Condiciones, puedes ponerte en contacto con nosotros en  <a href={"mailto:info@apatech.com.do"} target="_blank">info@apatech.com.do</a>.

            Fecha de entrada en vigencia: 10/01/2023

                    
        </div>

        )
}

export default CondicionesServicio